import React from 'react';
import {Card, CardText} from 'material-ui/Card';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import Chip from 'material-ui/Chip';
import Checkbox from 'material-ui/Checkbox';
import SvgIcon from 'material-ui/SvgIcon';

const UnCheckIcon = (props) => (
    <SvgIcon {...props}>
       <path id="SvgjsPath1016" d="M29 648.2C29 647.5372600000001 29.53726 647 30.2 647H60.8C61.46274 647 62 647.53726 62 648.2V678.8000000000001C62 679.46274 61.46274 680.0000000000001 60.8 680.0000000000001H30.199999999999996C29.537259999999996 680.0000000000001 28.999999999999996 679.4627400000002 28.999999999999996 678.8000000000001Z " fill="#ffffff"></path><path id="SvgjsPath1014" d="M29 648.2C29 647.5372600000001 29.53726 647 30.2 647H60.8C61.46274 647 62 647.53726 62 648.2V678.8000000000001C62 679.46274 61.46274 680.0000000000001 60.8 680.0000000000001H30.199999999999996C29.537259999999996 680.0000000000001 28.999999999999996 679.4627400000002 28.999999999999996 678.8000000000001Z " fill="#ffffff" fillOpacity="1" transform="matrix(1,0,0,1,-29,-647)"></path><path id="SvgjsPath1015" d="M29 648.2C29 647.5372600000001 29.53726 647 30.2 647H60.8C61.46274 647 62 647.53726 62 648.2V678.8000000000001C62 679.46274 61.46274 680.0000000000001 60.8 680.0000000000001H30.199999999999996C29.537259999999996 680.0000000000001 28.999999999999996 679.4627400000002 28.999999999999996 678.8000000000001Z " fillOpacity="0" fill="#ffffff" strokeDashoffset="0" strokeLinejoin="miter" strokeLinecap="butt" strokeOpacity="1" stroke="#e6e6e6" strokeMiterlimit="50" strokeWidth="6" clipPath="url(&quot;#SvgjsClipPath1017&quot;)" transform="matrix(1,0,0,1,-29,-647)"></path>
    </SvgIcon>
);

const CheckIcon = (props) => (
    <SvgIcon {...props}>
        <defs id="SvgjsDefs1001"><clipPath id="SvgjsClipPath1010"><path id="SvgjsPath1009" d="M29 648.2C29 647.5372600000001 29.53726 647 30.2 647H60.8C61.46274 647 62 647.53726 62 648.2V678.8000000000001C62 679.46274 61.46274 680.0000000000001 60.8 680.0000000000001H30.199999999999996C29.537259999999996 680.0000000000001 28.999999999999996 679.4627400000002 28.999999999999996 678.8000000000001Z " fill="#ffffff"></path></clipPath></defs><path id="SvgjsPath1007" d="M29 648.2C29 647.5372600000001 29.53726 647 30.2 647H60.8C61.46274 647 62 647.53726 62 648.2V678.8000000000001C62 679.46274 61.46274 680.0000000000001 60.8 680.0000000000001H30.199999999999996C29.537259999999996 680.0000000000001 28.999999999999996 679.4627400000002 28.999999999999996 678.8000000000001Z " fill="#ffffff" fillOpacity="1" transform="matrix(1,0,0,1,-29,-647)"></path><path id="SvgjsPath1008" d="M29 648.2C29 647.5372600000001 29.53726 647 30.2 647H60.8C61.46274 647 62 647.53726 62 648.2V678.8000000000001C62 679.46274 61.46274 680.0000000000001 60.8 680.0000000000001H30.199999999999996C29.537259999999996 680.0000000000001 28.999999999999996 679.4627400000002 28.999999999999996 678.8000000000001Z " fillOpacity="0" fill="#ffffff" strokeDashoffset="0" strokeLinejoin="miter" strokeLinecap="butt" strokeOpacity="1" stroke="#e6e6e6" strokeMiterlimit="50" strokeWidth="6" clipPath="url(&quot;#SvgjsClipPath1010&quot;)" transform="matrix(1,0,0,1,-29,-647)"></path><path id="SvgjsPath1011" d="M55.99 655L41.660000000000004 670.71L34 662.32 " fillOpacity="0" fill="#ffffff" strokeDashoffset="0" strokeLinejoin="round" strokeLinecap="round" strokeOpacity="1" stroke="#1eaaf1" strokeMiterlimit="50" strokeWidth="3" transform="matrix(1,0,0,1,-29,-647)"></path>
    </SvgIcon>
);

const style = {
    card: {
        marginTop: 50
    },
    cardText: {
      padding: '0 16px'
    },
    block: {
        maxWidth: 250,
    },
    radioButton: {
        marginTop: 16,
        width: '50%',
        display: 'inline-block'
    },
    checkbox: {
        marginTop: 16,
        height: 33,
        width: '100%'
    },
    dropDown: {
      width: '100%',
      padding: 0,
    },
    checkIcon: {
        viewBox: '0 0 33 33'
    }
};

export default function (props) {
    const menuItems = [];
    for (const org of props.organizations) {
      const {organizationId: id, organizationName: name} = org;
      menuItems.push(<MenuItem value={id} primaryText={name} key={id} />)
    }
    return  <Card style={style.card} initiallyExpanded={true}>
        <CardText style={style.cardText} expandable={true}>
            <TextField fullWidth={true} onChange={props.changeHandlers.title}
                       floatingLabelText="Collection Title" value={props.title}/>
          <DropDownMenu
              value={props.selectedOrganization}
              style={style.dropDown}
              onChange={(event, index, value) => props.changeHandlers.organization(value)}
          >
            {menuItems}
          </DropDownMenu>
          <RadioButtonGroup onChange={props.changeHandlers.privacy} name="privacy" defaultSelected={props.privacy} >
                <RadioButton
                    value='USER_PRIVATE'
                    label='Only me'
                    style={style.radioButton}
                />
                <RadioButton
                    value='ORGANIZATION_PRIVATE'
                    label='Share with team'
                    style={style.radioButton}
                />
            </RadioButtonGroup>
            <TextField fullWidth={true} multiLine={true} floatingLabelText="Keywords" inputStyle={{height: '24px'}}
                       onChange={props.changeHandlers.keywords} value={props.keywordsStr}/>
            { props.keywords.length > 0 && props.keywords.map(k => {
               return <Chip key={k} style={{ margin: '8px 8px 0 0', float: 'left'}} onRequestDelete={() => props.changeHandlers.deleteKeyword(k)}>{k}</Chip>
            })}
            <TextField fullWidth={true} multiLine={true} floatingLabelText="Description"
                       onChange={props.changeHandlers.description} value={props.caption}/>
            <TextField fullWidth={true} multiLine={false} floatingLabelText="Credit" maxLength={100}
                       onChange={props.changeHandlers.attribution} value={props.attribution}/>
            <Checkbox uncheckedIcon={<UnCheckIcon viewBox={style.checkIcon.viewBox} />}
                       checkedIcon={<CheckIcon viewBox={style.checkIcon.viewBox} />} style={style.checkbox}
                       label="Show credit at the end of the video" onCheck={props.changeHandlers.attributionMode}
                       disabled={props.attribution === ''} checked={props.attributionMode !== 'NONE'} />
        </CardText>
    </Card>
}
